import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, ModalFooter, ModalBody } from '../../../misc/modals/modals'
import EmbedMaker from '../../../misc/modals/EmbedMaker'
import PrivacySettings from '../../../misc/modals/PrivacySettings'
import FileList from '../../../misc/modals/FileList'
import { deleteVideo, editVideo, EDIT_USER } from '../../../actions'
import { getEmbedCode } from '../../../misc/utilities'
import './videoItem.css'
import GridItem from './GridItem'
import Cookies from 'js-cookie'
import ClipboardButton from 'react-clipboard.js'
import { createAction } from 'redux-actions'

class VideoItem extends Component {
  constructor() {
    super()
    this.state = {
      embedModalOpen: false,
      deleteModalOpen: false,
      privacyModalOpen: false,
      privacyUpdated: false,
      fileListOpen: false,

    }
    this.toggleEmbedModal = this.toggleEmbedModal.bind(this)
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this)
    this.togglePrivacyModal = this.togglePrivacyModal.bind(this)
    this.toggleFileListModal = this.toggleFileListModal.bind(this)
    this.toggleSelect = this.toggleSelect.bind(this)
    this.setState = this.setState.bind(this)
    this.editTitle = this.editTitle.bind(this)
    this.resetEmbed = this.resetEmbed.bind(this)
  }

  toggleEmbedModal() {
    this.setState({
      clipped: false,
      defaultsSaved: false,
      embedModalOpen: !this.state.embedModalOpen,
    })
    this.resetEmbed()
  }

  resetEmbed() {
    const video = this.props.video
    const embedOptions = {
      autoplay: false,
      loop: true,
      ...JSON.parse(Cookies.get('embed_options') || '{}'),
      ...this.props.me.embed_options,
    }
    this.setState({
      embedOptions,
    })
  }

  toggleDeleteModal() {
    this.setState({
      deleteModalOpen: !this.state.deleteModalOpen,
    })
  }

  togglePrivacyModal() {
    if (this.privacyModal) {
      this.privacyModal.reset();
    }
    this.setState({
      privacyModalOpen: !this.state.privacyModalOpen,
      privacyUpdated: false,
    })
  }

  toggleFileListModal() {
    this.setState({
      fileListOpen: !this.state.fileListOpen,
    })
  }

  editTitle(title, debounced) {
    this.props.dispatch(editVideo(this.props.video.shortcode, { title }, debounced))
  }

  toggleSelect() {
    if (this.props.selected) {
      this.props.onDeselect()
    } else {
      this.props.onSelect()
    }
  }

  render() {
    const self = this
    const percent = this.props.video.percent

    return (
      <GridItem
        props={this.props}
        toggleDeleteModal={this.toggleDeleteModal}
        toggleSelect={this.toggleSelect}
        toggleEmbedModal={this.toggleEmbedModal}
        togglePrivacyModal={this.togglePrivacyModal}
        toggleFileListModal={this.toggleFileListModal}
        percent={percent}
        group={this.props.group}
        onTitleChange={(title, force) => {
          this.editTitle(title, !force)
        }}
        onReorder={this.props.onReorder}
        isMobile={this.props.isMobile}
      >
        <Modal
          isOpen={this.state.embedModalOpen}
          toggle={this.toggleEmbedModal}
          className="app-modal"
          title="Build Embed Code"
          darkMode={this.props.me.dark_mode}
        >
          <ModalBody>
            <EmbedMaker
              ref={(r) => {
                self.embedMaker = r
              }}
              options={self.state.embedOptions}
              onChange={(opts) => {
                self.setState({ embedOptions: opts, defaultsSaved: false })
              }}
              video={this.props.video}
            />
          </ModalBody>
          <ModalFooter>
            <ClipboardButton
              component="button"
              className={`blue-button ${self.state.clipped ? 'clipped' : ''}`}
              option-text={() => getEmbedCode(self.props.video, self.state.embedOptions)}
              onSuccess={() => {
                self.setState({ clipped: true })
                self.embedMaker.select()
                window.ga('send', 'event', 'Embeds', 'copied', 'dashboard_advanced')
              }}
              onError={() => self.embedMaker.select()}
            >
              {self.state.clipped ? 'Copied!' : 'Copy Embed Code'}
            </ClipboardButton>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.deleteModalOpen}
          toggle={this.toggleDeleteModal}
          className="app-modal"
          title="Delete Video"
          darkMode={this.props.me.dark_mode}
        >
          <ModalBody>
            Are you sure you want to delete{' '}
            {this.props.video ? this.props.video.title || 'this video' : 'this video'}
            ?
          </ModalBody>
          <ModalFooter>
            <button
              className="blue-button"
              onClick={() => {
                this.toggleDeleteModal()
                this.props.dispatch(deleteVideo(this.props.video))
              }}
            >Delete</button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.privacyModalOpen}
          toggle={this.togglePrivacyModal}
          className="app-modal"
          title="Privacy Settings"
          darkMode={this.props.me.dark_mode}
        >
          <ModalBody>
            <PrivacySettings
              ref={(r) => {
                self.privacyModal = r
              }}
              onChange={update => {
                this.setState({savedPrivacy: false})
                let changed = this.props.video.privacy != update.privacy || update.password
                if (update.privacy == 2 && !update.password) {
                  changed = false
                }
                self.setState({privacyUpdated: changed, privacySettings: {...this.state.privacySettings, ...update}})

              }}
              video={this.props.video}
              me={this.props.me}
            />
          </ModalBody>
          <ModalFooter>
            <button
              className="blue-button"
              disabled={!this.state.privacyUpdated}
              onClick={() => {
                this.props.dispatch(editVideo(this.props.video.shortcode, this.state.privacySettings, false, false, true))
                this.setState({savedPrivacy: true, privacyUpdated: false})
                this.privacyModal.reset();
              }}
            >{this.state.savedPrivacy ? 'Changes Saved!' : 'Save Changes'}</button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.fileListOpen}
          toggle={this.toggleFileListModal}
          className="app-modal"
          title="Download"
          darkMode={this.props.me.dark_mode}
        >
          <ModalBody>
            <FileList
              ref={(r) => {
                self.fileListModal = r
              }}
              video={this.props.video}
              me={this.props.me}
            />
          </ModalBody>
        </Modal>
        {this.props.showWelcome && this.props.video.status < 3 ?
          <div className="callout">
            <div className="callout-close" onClick={e => this.props.dispatch(createAction(EDIT_USER)({ first_run: false }))}>✕</div>
            {this.props.video.status == 2 ? 
              <div>
                <h1>Your video is ready!</h1>
                You can now share the link or {this.props.video.upload_source == 'compress' ? 'download the compressed file' : 'edit the video'} — and much more!
              </div>
              :
              <div>
                <h1>Your video is in the works!</h1>
                {this.props.video.upload_source == 'compress' ? 'Your download will be ready soon.' : `You video will be ready for viewing soon.`} In the meantime, you can copy the link or edit the video title.
              </div>
            }
            <button className="callout-close-button" onClick={e => this.props.dispatch(createAction(EDIT_USER)({ first_run: false }))}>OK</button>

          </div>
        : ''}
      </GridItem>
    )
  }
}

export default connect()(VideoItem)
